var $ = require( "jquery" );

require("./select2.js");
require("./Swiper.js");
require("./Parallax.js");
const T = require("./Theorie.js")($);


const CQ = require("./communales/Quizz.js")($);
const CDD = require("./communales/DragAndDrop.js")($);
const CV = require("./communales/Vote.js")($, CQ, CDD);

const LQ = require("./legislatives/Quizz.js")($);
const LDD = require("./legislatives/DragAndDrop.js")($);
const LV = require("./legislatives/Vote.js")($, LQ, LDD);

const EQ = require("./europeennes/Quizz.js")($);
const EDD = require("./europeennes/DragAndDrop.js")($);
const EV = require("./europeennes/Vote.js")($, EQ, EDD);


$('.ResetAll').on('click', function(){

    CQ.clear_all();
    CDD.clear_all();
    CV.clear_all();

    LQ.clear_all();
    LDD.clear_all();
    LV.clear_all();

    EQ.clear_all();
    EDD.clear_all();
    EV.clear_all();

    // sessionStorage.removeItem('LetzvoteCommunales');
    // sessionStorage.removeItem('CommunalesQuizz');
    // sessionStorage.removeItem('CommunalesDragAndDrop');
    // sessionStorage.removeItem('CommunalesVote');
    // sessionStorage.removeItem('CommunalesCommune');
    //
    // sessionStorage.removeItem('LetzvoteLegislatives');
    // sessionStorage.removeItem('legislativesQuizz');
    // sessionStorage.removeItem('LegislativesDragAndDrop');
    // sessionStorage.removeItem('LegislativesVote');
    // sessionStorage.removeItem('LegislativesCommune');
    //
    // sessionStorage.removeItem('LetzvoteEuropeennes');
    // sessionStorage.removeItem('EuropeennesQuizz');
    // sessionStorage.removeItem('EuropeennesDragAndDrop');
    // sessionStorage.removeItem('EuropeennesVote');

    // let currentUrl = window.location.href;
    // let urlWithoutHash = currentUrl.split('#')[0];
    // window.location.replace(urlWithoutHash);

    window.location.href = WP.siteurl;

});


require("./scrolling.js")($);
require("./TabsGroup.js")($, T, CDD, CV, LDD, LV, EDD, EV);


require("./menu.js")($);


$('.block.elections .items .item').each(function(index){
    let i = index + 1;
    let total = $('.block.elections .items .item').length;

    $(this).on('mouseover', function(){
        $('.block.elections .items .item').removeClass('after before here');
        for (let j=0; j<=total; j++){
            if( j<i ){
                $('.block.elections .items .item:nth-child('+j+')').addClass('before');
            } else if( j>i ) {
                $('.block.elections .items .item:nth-child('+j+')').addClass('after');
            } else {
                $('.block.elections .items .item:nth-child('+j+')').addClass('here');
            }
        }
    })
});
